import { render } from "./AppFooter.vue?vue&type=template&id=c54c415e&scoped=true&ts=true"
import script from "./AppFooter.vue?vue&type=script&lang=ts"
export * from "./AppFooter.vue?vue&type=script&lang=ts"

import "./AppFooter.vue?vue&type=style&index=0&id=c54c415e&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c54c415e"]])

export default __exports__